import { ChainId } from '@uniswap/sdk'
import MULTICALL_ABI from './abi.json'

const MULTICALL_NETWORKS: { [chainId in ChainId]: string } = {
  [ChainId.MUMBAI]: '0xc124c6C1a4A04478ab14451495339B9278086914', //TODO: CHANGE THIS
  [ChainId.MATIC]:  '0xc124c6C1a4A04478ab14451495339B9278086914'
}

export { MULTICALL_ABI, MULTICALL_NETWORKS }
